import React, { useState } from 'react';
import Header from '../components/Header';
import Mockup from '../components/Mockup';
import Footer from '../components/Footer';
import data from '../Games.json'
import StarWars from './starwars.mp4';
import TomAndJerry from './tomandjerry.mp4';
import MrBeen from './mrbean.mp4';
import Slider from "react-slick";

import { LazyLoadImage } from 'react-lazy-load-image-component';

import { useIsMobile } from '../helpers/IsMobile'

export default function Games() {

  const games = [
    {
      title: "Star Wars Rebels - Special Ops",
      category: "Star Wars",
      description: "Enjoy the exciting game Star Wars Rebels - Special Ops!",
      video: StarWars,
      image: "https://gamesbox.s3.eu-central-1.amazonaws.com/Star+Wars/Star+Wars+Rebels+-+Special+Ops/screenshot.jpg"
    },
    {
      title: "Tom and Jerry - What's the Catch",
      category: "Tom And Jerry",
      description: "Get on your surfboard, grab a bow and destroy the evil skeletons before they kill you!",
      video: TomAndJerry,
      image: "https://gamesbox.s3.eu-central-1.amazonaws.com/Tom+and+Jerry/Tom+and+Jerry+-+What's+the+Catch/screenshot.jpg"
    },
    {
      title: "Mr. Bean - Goldfish Loopy Loopy",
      category: "Mr. Bean",
      description: "Enjoy the exciting game Mr. Bean - Goldfish Loopy Loopy!",
      video: MrBeen,
      image: "https://gamesbox.s3.eu-central-1.amazonaws.com/Mr.+Bean/Mr.+Bean+-+Goldfish+Loopy+Loopy/screenshot.jpg"
    }
  ];


  const [activeCategory, setActiveCategory] = useState(data[0]?.Name || '');


  const isMobile = useIsMobile();

  var settings = {
    dots: false,
    infinite: false,
    arrows: false,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 3,
    initialSlide: 0,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          arrows: true,

          slidesToScroll: 3

        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2,
          arrows: true,
          initialSlide: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          arrows: false,
          slidesToScroll: 1
        }
      }
    ]
  };


  return (
    <div>
      <Header />

      <section>
        <div id="gameCarousel" className="carousel slide w-100" data-bs-ride="carousel">
          <div className="carousel-indicators">
            {games.map((_, i) => (
              <button
                key={i}
                type="button"
                data-bs-target="#gameCarousel"
                data-bs-slide-to={i}
                className={i === 0 ? 'active' : ''}
                aria-current={i === 0 ? 'true' : undefined}
                aria-label={`Slide ${i + 1}`}
              />
            ))}
          </div>

          <div className="carousel-inner">
            {games.map((game, i) => (
              <div key={i} className={`carousel-item ${i === 0 ? 'active' : ''}`} style={{ position: 'relative' }}>
                <video
                  className="d-block"
                  style={{ objectFit: 'contain', height: '80vh', width: '100%', objectFit: 'cover' }}
                  autoPlay
                  muted
                  loop
                  playsInline
                >
                  <source src={game.video} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>

                <div
                  className="carousel-caption" >

                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'self-start', width: '80%' }} >
                    <div className='d-flex flex-row align-items-center  gap-3 flex-wrap' >
                      <img src={game.image} alt="Game thumbnail" style={{ maxWidth: '200px', marginBottom: '1rem', borderRadius: '15px' }} />
                      <div className='d-flex flex-column align-items-start' >
                        <h5 className='text-start' >{game.title}</h5>
                        <p className='text-start' >{game.category}</p>
                      </div>
                    </div>
                    <p className='text-start' >{game.description}</p>
                    <button className="btn btn-primary">Play Game</button>
                  </div>


                </div>



              </div>
            ))}
          </div>

          {!isMobile ? (
            <>
              <button className="carousel-control-prev" type="button" data-bs-target="#gameCarousel" data-bs-slide="prev">
                <span className="carousel-control-prev-icon" aria-hidden="true" />
                <span className="visually-hidden">Previous</span>
              </button>
              <button className="carousel-control-next" type="button" data-bs-target="#gameCarousel" data-bs-slide="next">
                <span className="carousel-control-next-icon" aria-hidden="true" />
                <span className="visually-hidden">Next</span>
              </button>
            </>
          ) : null}



        </div>
      </section>



      <div className="container py-4">


        {/* Nav Pills Carousel New*/}
        <Slider {...settings}>
          {data.map((category, index) => (

            <ul className="nav nav-pills flex-nowrap">
              <li className="nav-item me-2" key={index}>
                <button
                  className={`nav-link ${activeCategory === category.Name ? 'active-link' : ''}`}
                  onClick={() => setActiveCategory(category.Name)}
                >
                  {category.Name}
                </button>
              </li>
            </ul>
          ))}
        </Slider>



        {/* Games Display */}
        <div className="row mt-5" key={activeCategory} style={{ minHeight: '20vh' }}>
          {data
            .find(category => category.Name === activeCategory)
            ?.Content.map((game, index) => (
              <div
                key={index}
                className="col-6 col-sm-4 col-md-3 col-lg-2 mb-4 d-flex align-items-stretch"
              >
                <div className="w-100" style={{ maxHeight: '100px', borderRadius: '15px' }}>
                  <LazyLoadImage
                    style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '10px' }}
                    alt={game.Title}
                    src={game.Thumbnail_Large}
                    effect="blur"
                    wrapperProps={{
                      style: { transitionDelay: '1s' },
                    }}
                  />
                </div>
              </div>
            ))}
        </div>



      </div>

      <Mockup />


      <Footer />
    </div>
  );
}
